import { Profile } from '@staffedupusa/shared-components';
import { getCookie } from './getCookie';
interface StatusUpdate {
  walkthrough_status: number;
}
const checkPlan1Status = (user?: Profile | null, type?: string) => {
  const isChecked =
    !user?.has_shared_page ||
    !user?.has_image ||
    (!user?.company?.check_list?.has_visited_qualification_question_page) ||
    !user?.company?.check_list?.has_visited_job_posting_page ||
    ((!user?.company?.check_list?.has_added_pre_qualification_questions ||
      !user?.company?.auto_save_applications ||
      !user?.calendar_count ||
      !user?.company?.auto_interview_invite) &&
      !user?.has_facebook_page_id);
  if (isChecked) return false;
  return true;
};

const checkPlan4Status = (user?: Profile | null, type?: string) => {
  const inboxChecked = getCookie('inboxChecked');
  const isChecked =
    !user?.has_shared_page ||
    !user?.has_image ||
    !inboxChecked ||
    (type !== 'question' && !user?.company?.check_list?.has_visited_qualification_question_page) ||
    !user?.company?.check_list?.has_visited_job_posting_page;

  if (isChecked) return false;

  return true;
};

const checkPlan2Status = (user?: Profile | null, type?: string) => {
  const isChecked =
    !user?.has_shared_page ||
    !user?.has_image ||
    (!user?.company?.check_list?.has_visited_qualification_question_page) ||
    !user?.company?.check_list?.has_visited_job_posting_page ||
    ((!user?.company?.check_list?.has_added_pre_qualification_questions ||
      !user?.company?.auto_save_applications ||
      !user?.calendar_count ||
      !user?.company?.auto_interview_invite) &&
      !user?.has_facebook_page_id) ||
    (!user?.package_template && !user?.has_mission_statement);
  if (isChecked) return false;
  return true;
};

export const updateWalkthroughStatus = (
  plan?: number,
  user?: Profile | null,
  type?: string,
  updateStatus?: (status: StatusUpdate) => void,
): void => {
  if (!updateStatus) return;

  if (plan === 2 && checkPlan2Status(user, type)) {
    updateStatus({ walkthrough_status: 2 });
  }
  if (plan === 1 && checkPlan1Status(user, type)) {
    updateStatus({ walkthrough_status: 2 });
  }
  if (plan === 4 && checkPlan4Status(user, type)) {
    updateStatus({ walkthrough_status: 2 });
  }
};
